
import { hiddenErrorsService } from "@/services/hiddenErrorsService";
import { computed, defineComponent } from "vue";

export default defineComponent({
	setup() {
		const { hiddenErrors, unhideError } = hiddenErrorsService;
		const errors = computed(() => [...hiddenErrors.value].reverse());
		return { errors, unhideError };
	},
});
